export type AuditMetadata = {
  userAgent?: string
  ipAddress?: string
}

const IP_PROBE_URL = 'https://api.ipify.org?format=json'
const IP_PROBE_TIMEOUT_MS = 2000

export async function collectAuditMetadata(): Promise<AuditMetadata> {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined
  let ipAddress: string | undefined
  try {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), IP_PROBE_TIMEOUT_MS)
    try {
      const response = await fetch(IP_PROBE_URL, { signal: controller.signal })
      if (response.ok) {
        const json = (await response.json()) as { ip?: string }
        if (typeof json.ip === 'string' && json.ip.length > 0) {
          ipAddress = json.ip
        }
      }
    } finally {
      clearTimeout(timeout)
    }
  } catch {
    ipAddress = undefined
  }
  return { userAgent, ipAddress }
}
